module.exports = __webpack_public_path__ + "img/allow-down.01a0daa9.svg";